import { Fragment, useState } from 'react';
import { Button, Modal, Table } from 'semantic-ui-react';

function ReportsChangesConfirmationModal({ data, targetedDescriptorId, onConfirm, onCancel,
    title = 'Confirm sign flip — save the following changes?' }) {
    const [loading, setLoading] = useState(false)
    const { reports, descriptors } = data;

    function handleSave() {
        setLoading(true);
        onConfirm(() => setLoading(false));
    }

    const metadataRows = [
        { label: 'Report ID', key: 'reportId' },
        { label: 'Year', key: 'year' },
        { label: 'Period', key: 'period' },
        { label: 'Version', key: 'version' },
        { label: 'Format', key: 'format' },
        { label: 'Source', key: 'source' },
    ];

    return (
        <Modal size="large" open={true} closeOnEscape={!loading} closeOnDimmerClick={!loading} onClose={onCancel}>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content className="overflowYScroll">
                <Table celled>
                    <Table.Body>
                        {metadataRows.map(({ label, key }) => (
                            <Table.Row key={key}>
                                <Table.Cell>
                                    <b>{label}</b>
                                </Table.Cell>
                                {reports.map((r) => (
                                    <Table.Cell key={r.reportMetadata.reportId} colSpan={2}>
                                        {r.reportMetadata[key]}
                                    </Table.Cell>
                                ))}
                            </Table.Row>
                        ))}
                        <Table.Row>
                            <Table.Cell><b>Field</b></Table.Cell>
                            {reports.map((r) => (
                                <Fragment key={r.reportMetadata.reportId}>
                                    <Table.Cell><b>Current</b></Table.Cell>
                                    <Table.Cell><b>Proposed</b></Table.Cell>
                                </Fragment>
                            ))}
                        </Table.Row>
                        {descriptors.map(({ id, label }) => (
                            <Table.Row key={id} warning={id === targetedDescriptorId}>
                                <Table.Cell>{label}</Table.Cell>
                                {reports.map((r) => {
                                    const change = r.changeMap[id];
                                    return (
                                        <Fragment key={r.reportMetadata.reportId}>
                                            <Table.Cell>{change ? change.old : ''}</Table.Cell>
                                            <Table.Cell>{change ? change.new : ''}</Table.Cell>
                                        </Fragment>
                                    );
                                })}
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            </Modal.Content>
            <Modal.Actions>
                <Button disabled={loading} onClick={onCancel}>
                    Cancel
                </Button>
                <Button loading={loading} disabled={loading} onClick={handleSave} positive>
                    Save Changes
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default ReportsChangesConfirmationModal
